import { MultiLangField } from "src/app/shared/customization/multilang-input/multi-language";
import { Widget } from "./widget-models";
import { FormControl, Validators } from "@angular/forms";

export type dashboardDataType = 'kpi' | 'machine';

export interface DashboardConfig {
  id: string | null;
  scope: Scope;
  uidUser: string;
  createdBy: string;
  createdAt?: Date;
  modifiedAt?: Date;
  config: Dashboard;
  audience?: string;
}

export interface Dashboard {
  name: MultiLangField;
  icon: string | null;
  description: string;
  widgets: Widget[];
  dashboardDataType: dashboardDataType;
  type?: DashboardType;
  position?: DashboardPosition;
  state?: DashboardState;
  customers: string[] | string;
  customersPublished?: string[] | string;
  hiddenMenuItem?: boolean;
  settings: DashboardSettings;
  machineSettings?: MachineSettings | null;
}

export class DashboardSettings {
  minGridColumns: boolean = true;
  enableChartSync: boolean = false;
  enableChartSyncForUser: boolean = false;
  enableDefaultFilter: boolean = false;
  defaultFilterValue: string | null = null;
  editableFilter: boolean = true;
  /* dashboardDataType: dashboardDataType;
  type: DashboardType;
  position: DashboardPosition;
  state: DashboardState; */
}

export class MachineSettings {
  isDefault: boolean = true;
  uidCustomer: string | null = null;
  customerName?: string | null = null;
  brand: { uid: string, name: string } | null = null;
  models: { uid: string, name: string }[] = [];
}

export interface DashboardCreateModalData {
  id: string | null;
  isEdit: boolean;
  isDuplicate: boolean;
  dashboard: DashboardConfig;
  widgets: Widget[];
  dashboardDataType: dashboardDataType;
  dashboardSettings: DashboardSettings;
  onSaveSuccess?: () => void;
  onCancel?: () => void;
}

export class NewDashboardForm {
  id = new FormControl<string | null>(null, {});
  description = new FormControl<string | null>(null);
  type = new FormControl<DashboardType | null>(DashboardType.SELF, [Validators.required]);
  position = new FormControl<DashboardPosition | null>(DashboardPosition.INNERPAGE, [Validators.required]);
  isDefaultMachineDashboard = new FormControl<boolean>(true);
  brand = new FormControl<{ uid: string, name: string } | null>(null);
  models = new FormControl<{ uid: string, name: string }[]>([]);
}

export enum DashboardType {
  CUSTOMER = 'customer',
  SELF = 'user',
  ALL_MY_CUSTOMERS = 'global',
}

export enum DashboardState {
  PUBLISHED = 'published',
  OFFLINE = 'offline',
}

export enum DashboardPosition {
  MENUITEM = 1,
  INNERPAGE = 2,
  HOMEPAGE = 3
}

export enum Scope {
  DASHBOARD = 'dashboard',
}
